import React from 'react';
import { useSources } from 'app/shared/sources';

export const Source: React.FC<{ id: string }> = ({ id }) => {
  const sources = useSources();
  const source = sources.get(id);
  return source && source.fields.targetName ? <>{source.fields.targetName['en-US']}</> : null;
};
